import { useEffect, useId, useRef } from 'react';

export default function Modal({ titulo, onClose, children, largura = 480 }) {
  const dialogRef = useRef(null);
  const tituloId = useId();

  useEffect(() => {
    const anterior = document.activeElement;
    dialogRef.current?.focus();

    const aoTeclar = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', aoTeclar);
    return () => {
      document.removeEventListener('keydown', aoTeclar);
      anterior?.focus?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ background: 'rgba(27,27,22,.45)', zIndex: 1050 }}
      onClick={onClose}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={tituloId}
        tabIndex={-1}
        className="card-soft"
        style={{ width: '100%', maxWidth: largura, maxHeight: '90vh', overflowY: 'auto', outline: 'none' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: '20px 24px', borderBottom: '1px solid var(--am-borda-2)' }}
        >
          <h2 id={tituloId} style={{ fontSize: 17, fontWeight: 700, color: 'var(--am-tinta)', margin: 0 }}>
            {titulo}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="btn-close"
            aria-label="Fechar"
            style={{ fontSize: 12 }}
          />
        </div>
        <div style={{ padding: 24 }}>{children}</div>
      </div>
    </div>
  );
}
